import { TooltipV2 } from '@cimplico/components';
import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useFirmContext } from '../../providers/FirmProvider';
import { Worksheet } from '../../types/worksheet';
import { Combobox } from '@headlessui/react';
import { WorksheetStatusIcon } from '../../features/worksheet-v2/WorksheetStatusIcon';

type WorksheetResultItemProps = {
    worksheet: Worksheet;
    isLastItem: boolean;
    onNavigate: () => void;
};

function WorksheetResultItem({ worksheet, isLastItem, onNavigate }: WorksheetResultItemProps): JSX.Element {
    const { shortId } = useFirmContext();
    const [isOverflowed, setIsOverflow] = useState(false);

    const redirectUrl = `/${shortId}/workpapers/${worksheet.workpaperId}/${worksheet.account ? 'trial-balance' : 'other-schedules'}/${
        worksheet.id
    }`;
    const textElementRef = useRef(null);

    useEffect(() => {
        if (textElementRef.current) {
            // @ts-ignore
            setIsOverflow(textElementRef.current.scrollWidth > textElementRef.current.clientWidth);
        }
    }, [worksheet.name]);

    return (
        <Link
            key={worksheet.id}
            to={redirectUrl}
            onClick={onNavigate}
            onMouseDown={(e): void => {
                e.preventDefault();
                e.stopPropagation();
            }}
        >
            <Combobox.Option
                value={redirectUrl}
                className={({ active }): string =>
                    `flex items-center gap-2 marker:w-full p-1.5 text-xs text-indigo-600 dark:text-indigo-400 ${
                        active && 'bg-gray-100 dark:bg-white/[0.09]'
                    } ${!isLastItem && 'border-b border-gray-200 dark:border-white/[0.07]'}`
                }
            >
                <WorksheetStatusIcon status={worksheet.status} smallIcon />
                <TooltipV2 message={`${worksheet.name}`} disabled={!isOverflowed}>
                    <div className="w-[200px]">
                        <p ref={textElementRef} className="truncate font-medium">
                            {worksheet.name}
                        </p>
                    </div>
                </TooltipV2>
            </Combobox.Option>
        </Link>
    );
}

export default WorksheetResultItem;
